import { getAppConfig } from "services/configService";
import { rawGET, rawPOST } from "services/httpService";

const apiUrl = () => {
  return getAppConfig().StorageApiUrl;
};

export const getProductUploads = async (requestInfo, accountId, uploadId) => {
  const res = await rawGET(requestInfo, apiUrl() + `/uploads/${uploadId}?accountId=${accountId}`);

  if (res.status === 404) {
    return null;
  }

  if (!res.ok) {
    throw new Error(await res.text());
  }

  return res.json();
};

export const getAnonymousUploads = async (requestInfo, uploadId) => {
  const res = await rawPOST(requestInfo, apiUrl() + `/getanonymousuploads`, [uploadId]);

  if (res.status === 404) {
    return null;
  }

  if (!res.ok) {
    throw new Error(await res.text());
  }

  const result = await res.json();
  return result && result[0];
};
